/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRecurringTaskRequest
 */
export interface CreateRecurringTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringTaskRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringTaskRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringTaskRequest
     */
    initiativeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringTaskRequest
     */
    dimensionId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringTaskRequest
     */
    cadenceTier: CreateRecurringTaskRequestCadenceTierEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringTaskRequest
     */
    timezone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRecurringTaskRequest
     */
    evidenceRequired?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateRecurringTaskRequest
     */
    slaHours?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringTaskRequest
     */
    notes?: string;
}


/**
 * @export
 */
export const CreateRecurringTaskRequestCadenceTierEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY',
    Quarterly: 'QUARTERLY',
    Yearly: 'YEARLY'
} as const;
export type CreateRecurringTaskRequestCadenceTierEnum = typeof CreateRecurringTaskRequestCadenceTierEnum[keyof typeof CreateRecurringTaskRequestCadenceTierEnum];


/**
 * Check if a given object implements the CreateRecurringTaskRequest interface.
 */
export function instanceOfCreateRecurringTaskRequest(value: object): value is CreateRecurringTaskRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('initiativeId' in value) || value['initiativeId'] === undefined) return false;
    if (!('cadenceTier' in value) || value['cadenceTier'] === undefined) return false;
    return true;
}

export function CreateRecurringTaskRequestFromJSON(json: any): CreateRecurringTaskRequest {
    return CreateRecurringTaskRequestFromJSONTyped(json, false);
}

export function CreateRecurringTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecurringTaskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'initiativeId': json['initiativeId'],
        'dimensionId': json['dimensionId'] == null ? undefined : json['dimensionId'],
        'cadenceTier': json['cadenceTier'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'evidenceRequired': json['evidenceRequired'] == null ? undefined : json['evidenceRequired'],
        'slaHours': json['slaHours'] == null ? undefined : json['slaHours'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CreateRecurringTaskRequestToJSON(json: any): CreateRecurringTaskRequest {
    return CreateRecurringTaskRequestToJSONTyped(json, false);
}

export function CreateRecurringTaskRequestToJSONTyped(value?: CreateRecurringTaskRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'initiativeId': value['initiativeId'],
        'dimensionId': value['dimensionId'],
        'cadenceTier': value['cadenceTier'],
        'timezone': value['timezone'],
        'evidenceRequired': value['evidenceRequired'],
        'slaHours': value['slaHours'],
        'notes': value['notes'],
    };
}

